import React, { useState } from "react";
import { BedDouble, ShowerHead, CarFront } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const allProjects = [
  {
    title: "22 Ursula Street, Winston Hills",
    image:
      "https://arkbuild-cdn.s3.ap-southeast-2.amazonaws.com/images/22Ursulla/exterior.JPG",
    beds: 5,
    baths: 4,
    cars: 2,
    category: "New Builds",
    status: "Under Construction",
    link: "22-Ursula-Street-Winston-Hills",
  },
  {
    title: "1 Madonna Street, Winston Hills",
    image:
      "https://arkbuild-cdn.s3.ap-southeast-2.amazonaws.com/images/1Madonna/exterior.JPG",
    beds: 5,
    baths: 5,
    cars: 2,
    category: "New Builds",
    status: "Under Construction",
    link: "1-Madonna-Street-Winston-Hills",
  },
  {
    title: "42A Sutton Street, Blacktown",
    image:
      "https://arkbuild-cdn.s3.ap-southeast-2.amazonaws.com/images/42ASutton/sutton1.jpg",
    beds: 2,
    baths: 1,
    cars: 0,
    category: "New Builds",
    status: "Completed",
    link: "42A-Sutton-Street-Blacktown",
  },
  {
    title: "42 Sutton Street, Blacktown",
    image:
      "https://arkbuild-cdn.s3.ap-southeast-2.amazonaws.com/images/42Sutton/42sutton1.png",
    beds: 3,
    baths: 1,
    cars: 1,
    category: "Renovations",
    status: "Renovation",
    link: "42-Sutton-Street-Blacktown",
  },
];

const categories = ["All", "New Builds", "Renovations"];

const FeaturedProjectsPage = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredProjects =
    activeCategory === "All"
      ? allProjects
      : allProjects.filter((p) => p.category === activeCategory);

  return (
    <div className="bg-[#F7F4EA] min-h-screen px-6 md:px-16 py-20 text-[#333] font-sans">
      {/* Header */}
      <div className="text-center my-12">
        <div className="uppercase text-sm tracking-wide font-light mb-2">
          Featured Work
        </div>
        <h1 className="text-4xl md:text-5xl font-light leading-tight">
          Let Our Work Do The Talking
        </h1>
      </div>

      {/* Filters */}
      <div className="flex justify-center gap-8 mb-12">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`text-lg transition-all duration-300 ${
              activeCategory === cat
                ? "text-black underline underline-offset-4"
                : "text-gray-400 hover:text-black"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Project Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {filteredProjects.map((project, i) => (
          <Link to={`/featured-work/${project.link}`} key={i}>
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="bg-white rounded-xl shadow-md overflow-hidden group cursor-pointer"
            >
              <div className="relative w-full h-[300px] overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-105"
                />
                {/* Badge */}
                <div className="absolute top-3 left-3 bg-black/70 text-white text-xs px-3 py-1 rounded-full">
                  {project.status}
                </div>
              </div>

              <div className="p-4">
                <h3 className="text-lg font-medium mb-2 text-center">
                  {project.title}
                </h3>

                <div className="flex justify-center gap-6 text-sm text-gray-700">
                  <div className="flex items-center gap-1">
                    <BedDouble size={16} /> {project.beds}
                  </div>
                  <div className="flex items-center gap-1">
                    <ShowerHead size={16} /> {project.baths}
                  </div>
                  {project.cars > 0 && (
                    <div className="flex items-center gap-1">
                      <CarFront size={16} /> {project.cars}
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FeaturedProjectsPage;
